export const getActiveWorkspace = (state) => state?.workspaces?.activeWorkspace;

export const getWorkspacePermissions = (state) => getActiveWorkspace(state)?.permissions || [];

export const isOwner = (state) => getActiveWorkspace(state)?.role === "OWNER";
